import { isIP } from "is-ip"


function getHtmlOrigin(){
    if(typeof window === "undefined")return ""
    if(!isIP(window.location.hostname) && window.location.hostname !== "homepage.vm-ubuntu.droidlego.com")return window.location.origin + "/"
    // return `${window.location.protocol}://${window.location.hostname}:5173/`
    return `${window.location.protocol}//htmls.vm-ubuntu.droidlego.com/`
}
class Env{
    htmlOrigin:string = getHtmlOrigin()
}
export const env = new Env()